const autoNgTemplateLoaderTemplate1 = require('./configurations.html');

angular.module('shbdeployer.kubernetes').component('kubernetesConfigurationsView', {
  templateUrl: autoNgTemplateLoaderTemplate1,
  controller: 'KubernetesConfigurationsController',
  controllerAs: 'ctrl',
});
